import RichTextInput from "ra-input-rich-text";
import React, { useEffect } from "react";
import { useField } from "react-final-form";

interface IInternalNoteInput {
  record: any;
}

const InternalNoteInput = ({ record }: IInternalNoteInput) => {
  const {
    input: { onChange },
  } = useField("internalNote");

  useEffect(() => {
    if (record) {
      if (record.internalNote) {
        onChange(record.internalNote);
      }
    }
  }, [record]);

  return <RichTextInput label="Internal Note" source="internalNote.value" />;
};

export default InternalNoteInput;
